import { useEffect, useState } from "react";

/**
 * Returns a Date.now() value that updates every `intervalMs` ms.
 * Use for live countdown timers; share one tick across cards by lifting it
 * into a parent component so you don't get one timer per card.
 */
export function useNowTick(intervalMs = 1000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);
  return now;
}
